import ReactDOM from 'react-dom/client';
import './assets/styles/global.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import MedusaApp from './medusa-app';
import { setupApiInterceptor, setupXHRInterceptor } from './utils/api-interceptor';

async function run() {
  setupApiInterceptor();
  setupXHRInterceptor();

  const app = new MedusaApp();

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(app.render());
}

run();
